// extracted by mini-css-extract-plugin
export default {"base":"Z5bgA","reportCard":"YdRiH","reportCardItem":"X1Lh8","iconContainer":"VwOeR","textContent":"plorN","heading":"Rl1SV","description":"pTOwF"};